import { createFileRoute } from '@tanstack/react-router';
import { StandardRemunerationNotificationProfileRegistryPage } from './-components/StandardRemunerationNotificationProfileRegistryPage';
export const Route = createFileRoute('/_staff/salary-and-wages-mock/_layout/settings/standard-remuneration-notifications/')({
  component: StandardRemunerationNotificationProfileRegistryPage
});